function toggleServices() {
  $(document).on('click', '.article__button', function() {
    $(this).closest('.article__coupon').addClass('active');
  });

  $(document).on('click', '.article__promocode button', function(e) {
    e.preventDefault();

    const promoText = $(this).siblings('span').text().trim();

    if (promoText) {
      // Современный API копирования
      navigator.clipboard.writeText(promoText).then(() => {
        $(this).siblings('span').addClass('copied');
        setTimeout(function() {
          $('.article__promocode span ').removeClass('copied');
        }, 1000);
      }).catch(err => {
        console.error('Ошибка копирования: ', err);
      });
    }
  });

}
toggleServices();
